import { render, staticRenderFns } from "./dubbingTeacher.vue?vue&type=template&id=4f3ad24d&scoped=true"
import script from "./dubbingTeacher.vue?vue&type=script&lang=js"
export * from "./dubbingTeacher.vue?vue&type=script&lang=js"
import style0 from "./dubbingTeacher.vue?vue&type=style&index=0&id=4f3ad24d&prod&scoped=true&lang=css"
import style1 from "./dubbingTeacher.vue?vue&type=style&index=1&id=4f3ad24d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ad24d",
  null
  
)

export default component.exports